// extracted by mini-css-extract-plugin
module.exports = {"root":"HeroSignUpForm_root__LKSJZ","signUpForm":"HeroSignUpForm_signUpForm__X1IkO","welcomeOinq":"HeroSignUpForm_welcomeOinq__SvaXs","oinqIn":"HeroSignUpForm_oinqIn__z5icm"};